module.exports = __webpack_public_path__ + "static/iso_3.df49b063.jpg";